export const strNonEmpty = str => {
  return str && str.length > 0;
};

export default strNonEmpty;
